export const ATTRIBUTE_KEY_PREFIX = 'af-';
const ATTRIBUTE_PREFIX_REGEXP = new RegExp(`^${ATTRIBUTE_KEY_PREFIX}+`);
const isKeyThatShouldNeverHavePrefix = (key: string) => ['brand'].includes(key);

export const isMissingAfPrefix = (key: string) =>
    !isKeyThatShouldNeverHavePrefix(key) &&
    !key.startsWith(ATTRIBUTE_KEY_PREFIX);

export const getAttributesWithoutPrefix = (queryParams: {
    [key: string]: string;
}) =>
    Object.keys(queryParams).reduce((previousValue, key) => {
        if (isMissingAfPrefix(key)) {
            return previousValue;
        }
        const keyWithoutPrefix = key.replace(ATTRIBUTE_PREFIX_REGEXP, '');
        const values = decodeURIComponent(queryParams[key]).split(';');
        return {
            ...previousValue,
            [keyWithoutPrefix]: values
        };
    }, {});
